import { Component, Renderer2} from '@angular/core';
import { Title } from '@angular/platform-browser';
//import { SidebarService } from './share-module/sidebar.service';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import {LayoutService} from 'src/app/shared/Services/layout.service'
import { Constant } from "src/app/shared/Constants/constant";
import { StorageService } from 'src/app/shared/Services/storage.service';
import { LoaderService } from './shared/Services/loader.service';
import { environment } from 'src/environments/environment';
import { LoggingService } from './shared/Services/NGLogger/logging-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  sidebarStatus: boolean=true;
  isLogin = 'false';
  sidebarVisible = false;
  showHeader = true;
  showFooter = true;
  ClientType!:string;
  ConstantClient!:string;
  constructor(private renderer: Renderer2,private _titleService : Title, private layoutService:LayoutService,private router: Router,
    public storageService: StorageService, private loaderService : LoaderService, private  loggerservice: LoggingService) {
      var newTitle = 'Verisource';
      this._titleService.setTitle( newTitle );
    }

  ngOnInit() {
    //this.showHideSideBar();
    this.ClientType = environment.ClientName;
    this.ConstantClient = Constant.Virtusa;
    this.setFavicon(environment.ClientFavIcon);
    this.layoutService.sideBar$.subscribe((show: boolean) => {
      this.sidebarVisible = show;
    });

    this.layoutService.showHeader$.subscribe((show: boolean) => {
      this.showHeader = show;
    });

    this.layoutService.showFooter$.subscribe((show: boolean) => {
      this.showFooter = show;
    });
  }

  myEmitter(e: any) {
  }

  // async showHideSideBar(){
  //   this.sidebarVisible = false;
  //   const url = await this.storageService.GetUrl();

  //   if (!Constant.ROUTE_HEADINGS.some((route: any) => url.includes(route))) {
  //     this.sidebarVisible = true;
  //   }
  //   else
  //   {
  //     this.storageService.clean();
  //     this.sidebarVisible = false;
  //   }
  // }

  setFavicon(faviconUrl: string) {
    // Find existing favicon element
    let link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || this.renderer.createElement('link');

    // Set the necessary attributes
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = faviconUrl;

    // If the favicon link doesn't exist, append it to the head
    this.renderer.appendChild(document.head, link);
  }

}
